module.exports = __webpack_public_path__ + "static/media/Savings_Diagram_Mobile_SV.5fae5440.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Savings_Diagram_Mobile_SV.png
// module id = 557
// module chunks = 0